import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import { FetchCompanyParams, FetchCompanyResponse } from './company.types';

const companyApiPath = (id: string) => `companies/${id}`;

export const getCompany = async ({
  id,
}: FetchCompanyParams): Promise<
  AxiosResponse<FetchCompanyResponse & ApiError>
> => {
  return instance
    .get<FetchCompanyResponse>(companyApiPath(id))
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
